export const PRODUCT_NAME = {
  IMPACT_TRACKER: 'Impact Tracker',
  TRACK_IMPACT: 'TrackImpact',
  IMPACT_ACADEMY: 'Impact Academy'
};
